import {
  Box,
  Button,
  Divider,
  Flex,
  RectangleStackIcon,
  Text,
  UsersIcon,
  type FlexProps,
} from 'components'
import { useCurrentUser } from 'components/providers'
import { useContext, useState } from 'react'
import { makeUserDisplayName, signOut, useOnline } from 'utils'
import AboutButton from '../components/AboutButton'
import { glassPanelStyle } from '../components/GlassPanel'
import { LoadingContext, SessionContext } from '../components/providers'
import { ContentSelect, VisitorSettings } from '../components/settings'

export default function InitView() {
  const online = useOnline()
  const user = useCurrentUser()
  const { updateStatus } = useContext(SessionContext)
  const { status } = useContext(LoadingContext)
  const [isDirty, setIsDirty] = useState(false)

  return (
    <Flex direction="column" flex={1}>
      <Flex direction="column" alignItems="center" justifyContent="space-between" p={4} flex={1}>
        <Box height={heights.auth} />

        <Flex
          align="flex-end"
          direction="column"
          gap={4}
          justify="center"
          height="550px"
          margin="auto"
          maxHeight="80vh"
          width="700px"
          maxWidth="90vw"
        >
          <Box height={heights.doneButton} />

          <Flex {...glassPanelStyle(1)} flex={1} direction="row" gap={12} overflow="hidden" p={7}>
            <Section width="275px" title="Select Facility" icon={<RectangleStackIcon size="sm" />}>
              <ContentSelect />
            </Section>

            <Divider orientation="vertical" />

            <Section flex={1} title="Manage Visitor" icon={<UsersIcon size="sm" />}>
              <VisitorSettings onDirty={setIsDirty} />
            </Section>
          </Flex>

          <Button
            backgroundColor="white"
            color="black"
            disabled={status !== 'done' || isDirty}
            onClick={() => updateStatus('screensaver')}
          >
            Done
          </Button>
        </Flex>

        {user ? (
          <Flex
            borderWidth="1px"
            borderColor="rgba(255, 255, 255, 0.30)"
            borderRadius="sm"
            alignItems="center"
            gap={2}
            height={heights.auth}
            overflow="hidden"
          >
            <Text textStyle="bodyMedium" pl={3}>
              {makeUserDisplayName(user)}
            </Text>
            <Button
              borderRadius="none"
              background="rgba(255, 255, 255, 0.10)"
              variant="ghost"
              onClick={() => signOut()}
            >
              Logout
            </Button>
          </Flex>
        ) : (
          <Box height={heights.auth} />
        )}
      </Flex>

      <AboutButton position="absolute" left={4} bottom={4} />
      {!online && (
        <Text position="absolute" right={6} bottom={6}>
          Offline
        </Text>
      )}
    </Flex>
  )
}

const heights = {
  doneButton: '44px',
  auth: '40px',
}

interface SectionProps extends Omit<FlexProps, 'children'> {
  title: string
  children: React.ReactNode
  icon: React.ReactNode
}

function Section({ title, children, icon, ...rest }: SectionProps) {
  return (
    <Flex overflowY="hidden" align="stretch" direction="column" gap={5} {...rest}>
      <Flex align="center" gap={3}>
        <Flex
          alignItems="center"
          background={overlayColor}
          borderRadius={999}
          height="38px"
          justifyContent="center"
          width="38px"
        >
          {icon}
        </Flex>
        <Text textStyle="h4">{title}</Text>
      </Flex>
      {children}
    </Flex>
  )
}

const overlayColor = 'rgba(255, 255, 255, 0.20)'
